var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var formGroup = require('../../components/formGroup');
var loaders = require('../../layout/components/loaders');
var ontologyColumns = require('../../../../../models/equipment/ontologyColumns');

var editClassColumnModal = Object.create(Model);

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


function buildUnitSuggestions(columnDefinition, units) {
  var seen = {};
  return ontologyColumns.getUnitsForKind(columnDefinition.kind, units).reduce(function (options, unitRecord) {
    [unitRecord && unitRecord.name].concat(Array.isArray(unitRecord && unitRecord.aliases) ? unitRecord.aliases : [])
      .forEach(function (value) {
        var trimmed = String(value || '').trim();
        if (!trimmed || seen[trimmed]) return;
        seen[trimmed] = true;
        options.push(trimmed);
      });
    return options;
  }, []);
}

async function ensureColumnMetadataOptions(options) {
  if (Array.isArray(options && options.availableKinds) && Array.isArray(options && options.availableUnits)) {
    return {
      availableKinds: options.availableKinds,
      availableUnits: options.availableUnits
    };
  }

  var responses = await Promise.all([
    loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/unit/dimensions',
      method: 'GET',
      background: true
    }),
    loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/unit',
      method: 'GET',
      background: true
    })
  ]);

  return {
    availableKinds: ontologyColumns.listKnownColumnKinds(responses[0]),
    availableUnits: Array.isArray(responses[1]) ? responses[1] : []
  };
}

editClassColumnModal.editDialogue = async function (columnDefinition, options) {
  var metadataOptions;
  try {
    metadataOptions = await ensureColumnMetadataOptions(options || {});
  } catch (error) {
    console.error('Unable to load ontology column metadata options', error);
    metadataOptions = {
      availableKinds: ontologyColumns.listKnownColumnKinds([]),
      availableUnits: []
    };
  }

  editClassColumnModal.portDefinition = columnDefinition;
  editClassColumnModal.modifiedPortDefinition = prop(Object.assign({
    kind: '',
    defaultUnit: ''
  }, ontologyColumns.normalizeColumnDefinition(columnDefinition) || {}));
  editClassColumnModal.availableKinds = metadataOptions.availableKinds;
  editClassColumnModal.availableUnits = metadataOptions.availableUnits;
  editClassColumnModal.errors = [];

  var submit = async function () {
    if (!editClassColumnModal.modifiedPortDefinition().name) {
      editClassColumnModal.errors.push('Columns should have a name');
      throw new Error('Columns should have a name');
    }

    var normalizedColumn = ontologyColumns.normalizeColumnDefinition(editClassColumnModal.modifiedPortDefinition());
    if (!normalizedColumn || !normalizedColumn.name) {
      editClassColumnModal.errors.push('Columns should have a name');
      throw new Error('Columns should have a name');
    }

    Object.keys(editClassColumnModal.portDefinition).forEach(function (key) {
      delete editClassColumnModal.portDefinition[key];
    });
    Object.assign(editClassColumnModal.portDefinition, normalizedColumn);

    if (options && options.submitCallback) {
      await options.submitCallback(editClassColumnModal.portDefinition);
    }
    modal.vm.close();
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(`Edit ${columnDefinition.name}: `);
  modal.vm.body = editClassColumnModal.view;
  modal.vm.buttons([
    {
      label: "Submit",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


editClassColumnModal.view = function () {
  var columnDefinition = editClassColumnModal.modifiedPortDefinition();
  var unitSuggestions = buildUnitSuggestions(columnDefinition, editClassColumnModal.availableUnits || []);
  var unitListId = 'ontology-column-unit-options';
  return m('form', {role:'form'}, [
    editClassColumnModal.errorView(),
    m(formGroup, [
      m('label', `Id: ${columnDefinition.id}`),
    ]),
    m(formGroup, [
      m('label', 'Name'),
      m('input.form-control', {
        type:'text', 
        oninput: function(ev) { editClassColumnModal.modifiedPortDefinition().name = ev.target.value; },
        value: columnDefinition.name,
      })
    ]),
    m(formGroup, [
      m('label', 'Kind'),
      m('input.form-control', {
        type: 'text',
        list: 'ontology-column-kind-options',
        oninput: function (ev) {
          editClassColumnModal.modifiedPortDefinition().kind = ev.target.value;
        },
        value: columnDefinition.kind || '',
      }),
      m('datalist', { id: 'ontology-column-kind-options' }, (editClassColumnModal.availableKinds || []).map(function (kind) {
        return m('option', { value: kind });
      }))
    ]),
    m(formGroup, [
      m('label', 'Default Unit'),
      m('input.form-control', {
        type: 'text',
        list: unitListId,
        oninput: function (ev) {
          editClassColumnModal.modifiedPortDefinition().defaultUnit = ev.target.value;
        },
        value: columnDefinition.defaultUnit || '',
        placeholder: 'Default unit'
      }),
      m('datalist', { id: unitListId }, unitSuggestions.map(function (unitName) {
        return m('option', { value: unitName });
      }))
    ])

  ])
}


module.exports = editClassColumnModal;
